import React, { useRef, useState, useEffect } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import moment from "moment";
import { formatMoneda } from "../../util/varios";
import { ClaveSupervisor } from "../configuracionGeneral/modalClaveSupervisor";
import axios from "axios";

const TablaHistoricoReten = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Planilla",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Fecha",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Período",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Nº de Retenciones",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto Retenido",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto Interes",
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto Recargo",
      textAlign: "center",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto Multa",
      textAlign: "center",
    },
    {
      id: "9",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Total a Pagar",
      textAlign: "center",
    },
    {
      id: "10",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Estatus",
      textAlign: "center",
    },
    {
      id: "11",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Planilla",
      textAlign: "center",
    },
    {
      id: "12",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Opciones",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar4, setMostrar4] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [periodo, setPeriodo] = useState(null);
  const txtAnio = useRef();

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const imprimirPago = (index) => (event) => {
    event.preventDefault();
    if (recordsAfterPagingAndSorting()[index].estatus !== "Por Pagar") {
      var idfactura = recordsAfterPagingAndSorting()[index].idfact;
      var titulo =
        recordsAfterPagingAndSorting()[index].estatusfac === 1
          ? "Certificado de Pago Electrónico"
          : "";
      var estatus =
        recordsAfterPagingAndSorting()[index].estatusfac === 1 ? "'-2'" : "'0'";
      var certificado =
        recordsAfterPagingAndSorting()[index].estatusfac === 1
          ? "true"
          : "false";
      var tipo =
        recordsAfterPagingAndSorting()[index].tipotransaccion === 1
          ? "Depo"
          : "Trans";

      window.open(
        op.reportes +
          "FACTURA=" +
          idfactura +
          "&titulo=" +
          titulo +
          "&estatus=" +
          estatus +
          "&certificado=" +
          certificado +
          "&reporte=" +
          tipo,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El pago no ha sido registrado.",
        icono: "error",
      });
    }
  };

  const verReporte = (index) => (event) => {
    event.preventDefault();

    if (recordsAfterPagingAndSorting()[index].numrete === 0 && props.agente) {
      window.open(
        op.reportes +
          "&IDAGENTE=" +
          props.agente +
          "&PERIODO=" +
          recordsAfterPagingAndSorting()[index].periodo +
          "&reporte=Comprobante",
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      var fecha = moment(fechaSistema).format("YYYY-MM-DD");
      window.open(
        op.reportes +
          "&IDAGENTE=" +
          props.agente +
          "&PERIODO=" +
          "'" +
          recordsAfterPagingAndSorting()[index].periodo +
          "'" +
          "&FECHASISTEMA=" +
          "'" +
          fecha +
          "'" +
          "&reporte=Retenciones",
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setMostrar2(true);
  };

  useEffect(() => {
    if (props.tabhist) {
      let hist = [];
      for (let i = 0; i < props.tabhist.length; i++) {
        if (props.tabhist[i].numrete !== null) {
          hist.push(props.tabhist[i]);
        }
      }
      setRecords(hist);
    }
  }, [props.tabhist]);

  const aceptaClaveSupervisor = () => {
    setMostrar2(false);
    procesarEliminar();
  };

  const cancelaClaveSupervisor = () => {
    setMostrar2(false);
  };

  const eliminarRetencion = (index) => (event) => {
    event.preventDefault();

    if (
      recordsAfterPagingAndSorting()[index].estatus === "Por Pagar" ||
      recordsAfterPagingAndSorting()[index].numrete === 0
    ) {
      setPeriodo(recordsAfterPagingAndSorting()[index].periodo);

      let msg = "Esta Seguro de Eliminar la retenciòn?.";
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Esta retención no puede ser eliminada.",
        icono: "error",
      });
    }
  };

  const procesarEliminar = () => {
    let endpoint = `${op.conexion}/api/retencion/eliminarretencion?agente=${props.agente}&periodo=${periodo}&fechasistema=${fechaSistema}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.valret === periodo) {
            props.onHideRenderizar();

            var mensaje =
              "La retenciòn ha sido eliminada de manera satisfactoria.";

            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: mensaje,
              icono: "exito",
            });
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "La retenciòn no pudo ser eliminada.",
              icono: "error",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  return (
    <div className="">
      <div style={{ backgroundColor: "#", height: "100%", width: "100%" }}>
        <div
          className="h-2"
          style={{
            fontFamily: "georgia",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "bold",
            color: "#007bff",
          }}
        ></div>
        <div className="row card mx-auto m-0">
          <div className="" style={{ margin: 0 }}>
            <TblContainer>
              <TblHead />
              <TableBody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <TableRow key={index} style={{ padding: "0" }}>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "left" }}
                      >
                        {item.planilla}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                      >
                        {moment(item.fechareten).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                      >
                        {item.periodo}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                      >
                        {item.numrete}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "right" }}
                      >
                        {formatMoneda(
                          item.monret
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "right" }}
                      >
                        {formatMoneda(
                          item.intereses
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "right" }}
                      >
                        {formatMoneda(
                          item.recargos
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "right" }}
                      >
                        {formatMoneda(
                          item.multas
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </TableCell>

                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "right" }}
                      >
                        {formatMoneda(
                          item.totalpagar
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                      >
                        {item.estatus === "Procesada" ? (
                          <i className="fas text-success fa-check-double">
                            {" "}
                            {item.estatus}
                          </i>
                        ) : (
                          <i className="fas text-danger fa-exclamation-triangle">
                            {" "}
                            {item.estatus}
                          </i>
                        )}
                      </TableCell>
                      <TableCell
                        style={{
                          color: "rgb(255, 0, 0 )",
                          padding: "3px",
                          width: "100px",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        <button
                          onClick={verReporte(index)}
                          className="btn btn-xs btn-primary rounded-pill"
                        >
                          <i className="fas fa-print"></i>
                        </button>
                      </TableCell>
                      <TableCell
                        className="justify-content-between"
                        style={{
                          color: "rgb(255, 0, 0 )",
                          padding: "3px",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        <button
                          onClick={imprimirPago(index)}
                          className="btn btn-xs btn-info rounded-pill"
                        >
                          <i className="fas fa-search"></i>
                        </button>
                        &nbsp;
                        <button
                          onClick={eliminarRetencion(index)}
                          className="btn btn-xs btn-danger rounded-pill"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </div>
          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
            }
          />
          <MensajeSiNo
            mensaje={mensajesino}
            onHideNo={() =>
              setMensajesino({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              })
            }
            onHideSi={handleCloseSi}
          />
        </div>
        <ClaveSupervisor
          show={mostrar2}
          supervisor="1"
          onHideCancelaSup={cancelaClaveSupervisor}
          onHideAceptaSup={aceptaClaveSupervisor}
        />
        <Dimmer active={activate} />
      </div>
    </div>
  );
};
export default TablaHistoricoReten;



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/tablaHistorico.js